module.exports = __webpack_public_path__ + "img/GreekTechPeltastS_ua.5f9fe3a2.webp";